var path = '/app/components/ui/stage-puzzleform/stage-puzzleform.html';
var html = "<img ng-src={{$ctrl.model.image}} ui-draggable=true drag=$ctrl.model class=geoform ng-style=$ctrl.styles />";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/stage-puzzleform/stage-puzzleform.html
// module id = 180
// module chunks = 0